import React from "react";
import ManageAssessment from "../../../../instructor/pages/Assessment/ManageAssessment";
import { ASSESSMENT_TYPES } from "../../../../instructor/pages/Assessment/assessmentType";

// Admins see every class; instructors only their own.
const ManageAssignment = () => (
  <ManageAssessment type={ASSESSMENT_TYPES.unit_test} classesUrl="/classes" />
);

export default ManageAssignment;
